import * as React from "react";
import View from "zq-ui-v3/components/View/View";

const Home: React.FC = () => {
  return (
    <View className="w-100 h-100 con-center noColor flex-column opacity-50">
      <img src="/logo_min.png" style={{ width: 280 }} />
    </View>
  );
};
export default Home;
